import service from "@/store/services/elixiopay-transactions-service";

export const state = () => ({
  list: {},
  elixiopayTransaction: {},
  meta: {},
  stats: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, elixiopayTransaction) => {
    state.elixiopayTransaction = elixiopayTransaction;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_STATS: (state, stats) => {
    state.stats = stats;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((elixiopayTransaction) => {
      commit("SET_RESOURCE", elixiopayTransaction);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((elixiopayTransaction) => {
      commit("SET_RESOURCE", elixiopayTransaction);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((elixiopayTransaction) => {
      commit("SET_RESOURCE", elixiopayTransaction);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  async getStats({ commit, dispatch }, params = {}) {
    return await service.getStats(params, this.$axios).then((stats) => {
      commit("SET_STATS", stats);
      return stats;
    });
  },

  async resync({ commit, dispatch }, transactionId) {
    return await service.resync(transactionId, this.$axios);
  },

  async initiatePayment({ commit, dispatch }, paymentData) {
    return await service.initiatePayment(paymentData, this.$axios);
  },

  async checkStatus({ commit, dispatch }, transactionId) {
    return await service.checkStatus(transactionId, this.$axios).then((result) => {
      if (result.success && result.data.transaction) {
        commit("SET_RESOURCE", result.data.transaction);
      }
      return result;
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page?.total || 0,
  elixiopayTransaction: (state) => state.elixiopayTransaction,
  stats: (state) => state.stats,
};

const elixiopayTransactions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default elixiopayTransactions;
